import React from 'react';

import { TableGridApiContextProvider } from '../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import { api } from '../../core/api';
import { QueryListTable } from './QueryListTable/QueryListTable';

interface Props {}

export const QueryListBlock: React.FC<Props> = () => {
  return (
    <TableGridApiContextProvider>
      <QueryListTable datasource={api.search.getPagedQueries} adminView={false} />
    </TableGridApiContextProvider>
  );
};
